import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiEpBillingActivefeature {
}
ApiEpBillingActivefeature.list = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/activefeature/`,
    method: "GET",
});
ApiEpBillingActivefeature.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/activefeature/${req.path.id}`,
    method: "GET",
});
//# sourceMappingURL=activefeature.js.map